import React from "react";
import { Select } from "antd";
import TimezoneList from "./TimezoneList";
import moment from "moment";
import momentTZ from "moment-timezone";

const { Option } = Select;

export const defaultCountry = "IN";

const handleSelectedUserCountryData = currentTimezone => {
  for (const key in TimezoneList) {
    const countryObj = TimezoneList[key];
    const zones = countryObj.zones;
    if (zones.includes(currentTimezone)) {
      return TimezoneList[key];
    } else {
      return TimezoneList[defaultCountry];
    }
  }
};

export const defaultCountryObj = handleSelectedUserCountryData(
  moment.tz.guess()
);

const countryCodes = [
  {
    country_code: 91,
    alpha_2_code: "IN",
    show_value: "+91",
    curreny_symbol: "₹",
    currency: "INR",
    date_format: {
      antd: "DD/MM/YYYY",
      rdp: "dd/mm/yyyy"
    }
  },
  {
    country_code: 1,
    alpha_2_code: "US",
    show_value: "+1",
    curreny_symbol: "$",
    currency: "USD",
    date_format: {
      antd: "mm-dd-yyyy",
      rdp: "mm-dd-yyyy"
    }
  },
  {
    country_code: 971,
    alpha_2_code: "AE",
    show_value: "+971",
    curreny_symbol: "AED",
    currency: "AED",
    date_format: {
      antd: "dd/mm/yyyy",
      rdp: "dd/mm/yyyy"
    }
  }
];

/**
 * @function Loader
 * @desc This function returns the loader structure
 */
export const CountryCodeOptions = props => {
  return (
    <Select
      value={`+${props.selectedCode}`}
      style={{ width: 65 }}
      onSelect={(val, obj) => props.handleCodeChange(val, obj)}
    >
      {countryCodes.map(obj => {
        return (
          <Option value={obj.country_code} countryCodeObj={obj}>
            {obj.show_value}
          </Option>
        );
      })}
    </Select>
  );
};
